import { Box, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { getMonthAccordingToBirthdayDay, getYearAccordingToBirthday } from '../../utils/dateFromat';
import { CategoryType, MonthEnum, PadithiEnum, PredictionType } from '../../utils/enums';
import { getIntervalByPredictionType, getPredictionLevel } from './prediction.util';

const PredictionTimeline = ({ filter, user }) => {

    let { conditionType, category, predictionType, month, day } = filter;

    const userCurrentTimezone = user?.userCurrentTimezone;

    const birthTimezone = user?.birthDetails?.timezone;

    const birthDate = user?.birthDetails.date

    month = month === MonthEnum.CURRENT_MONTH ? getMonthAccordingToBirthdayDay(birthDate, userCurrentTimezone, birthTimezone) : month


    const predictionLevel = useMemo(() => {
        
        return getPredictionLevel({ conditionType, category, predictionType })

    }, [conditionType, category, predictionType])


    const predictionInterval = useMemo(() => {
        return getIntervalByPredictionType({
            predictionType,
            birthDate,
            birthTZ: birthTimezone,
            currentTZ: userCurrentTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
            month,
            day,
        });
    }, [predictionType, month, day, birthDate, birthTimezone, userCurrentTimezone]);

    // Format interval for UI
    function formatIntervalForDisplay(predictionType, interval) {
        if (!interval) return "";
        if (predictionType === PredictionType.DAY) {
            return interval?.startDateFormatted
        }
        return `${interval?.startDateFormatted} - ${interval?.endDateFormatted}`;
    }

    const intervalDisplayText = formatIntervalForDisplay(predictionType, predictionInterval);

    return (
        <Box sx={{ mb: 1 }}>
            {(predictionLevel || intervalDisplayText) && (
                <Typography
                    variant="subtitle1"
                    sx={{ mb: 1, ml: 2, color: "text.secondary" }}
                >
                    {predictionLevel  && `${predictionLevel}: `}
                    {(predictionType !== PredictionType.YEAR || category !== CategoryType.PROMISE)  && intervalDisplayText && (
                        intervalDisplayText
                    )}
                </Typography>
            )}
        </Box>
    )
}

export default PredictionTimeline
